import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./Router";
import { ToastProvider } from "./contexts/ToastContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SupabaseAuthProvider } from "./hooks/useSupabaseAuth";
import { PlaywrightController } from "./components/playwright";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

// Wrap in StrictMode only in production to avoid double-runs in development
const App = () => (
  <ThemeProvider defaultTheme="healing">
    <ToastProvider>
      <SupabaseAuthProvider>
        <Router />
        {/* <PlaywrightController /> */}
      </SupabaseAuthProvider>
    </ToastProvider>
  </ThemeProvider>
);

root.render(
  import.meta.env.PROD ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
